import { styled } from '@mui/material'
import React from 'react'

import { Balance, Organization, SelectOption } from '@/app/types'

import AccountMenu from './account-menu'
import { accountNavMap } from './definitions'
import OrgBalance from './org-balance'

type Props = {
  activeOrg?: Organization
  balance?: Balance
  currentPage: string
  email: string
  organizations?: SelectOption<number>[]
  hasOrg: boolean
  accountMenuOpen: boolean
  orgListExpanded: boolean
  logout: () => void
  onAccountMenuToggle: () => void
  onPanelToggle: () => void
  onOrgSelect: (org: SelectOption<number>) => void
}

const DesktopAccountMenu: React.FC<Props> = ({
  activeOrg,
  balance,
  currentPage,
  email,
  organizations,
  hasOrg,
  accountMenuOpen,
  orgListExpanded,
  logout,
  onAccountMenuToggle,
  onPanelToggle,
  onOrgSelect,
}) => (
  <ItemContainer id="header-account">
    {hasOrg && (
      <OrgBalance
        balance={balance}
        balanceIsBelowNotificationAmount={activeOrg?.balanceIsBelowNotificationAmount || false}
      />
    )}
    <AccountMenuContainer>
      <AccountMenu
        activeOrg={activeOrg}
        currentPage={currentPage}
        email={email}
        hasOrg={hasOrg}
        menuOpen={accountMenuOpen}
        navItems={accountNavMap}
        organizations={organizations || []}
        panelExpanded={orgListExpanded}
        onLogoutClick={logout}
        onMenuToggle={onAccountMenuToggle}
        onOrganizationChange={({ label, value }) => {
          onAccountMenuToggle()
          onOrgSelect({ label, value })
        }}
        onPanelToggle={onPanelToggle}
      />
    </AccountMenuContainer>
  </ItemContainer>
)

const ItemContainer = styled('div')({
  display: 'flex',
})

const AccountMenuContainer = styled('div')({
  alignSelf: 'center',
})

export default DesktopAccountMenu
